import React, { useState } from 'react';
import { usePageMotion } from '../hooks/usePageMotion';
import './Contact.css';

const Contact: React.FC = () => {
  const root = usePageMotion<HTMLDivElement>();
  const [formData, setFormData] = useState({
    name: '',
    contact: '',
    message: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const text = `Olá, Samuel! Meu nome é ${formData.name}.\n\nMeu contato: ${formData.contact}\n\nSobre o projeto: ${formData.message}`;
    window.open(`https://wa.me/5561995234306?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer');
  };

  const contactInfo = [
    {
      icon: 'fas fa-envelope',
      title: 'Email',
      value: 'samuell.nerii@gmail.com',
      link: 'mailto:samuell.nerii@gmail.com'
    },
    {
      icon: 'fab fa-whatsapp',
      title: 'WhatsApp',
      value: '+55 61 99523-4306',
      link: 'https://wa.me/5561995234306'
    },
    {
      icon: 'fab fa-linkedin',
      title: 'LinkedIn',
      value: '/samuel-neri',
      link: 'https://www.linkedin.com/in/samuel-neri-b8841b18a/'
    },
    {
      icon: 'fab fa-github',
      title: 'GitHub',
      value: '@SamuelNeri',
      link: 'https://github.com/SamuelNeri'
    },
    {
      icon: 'fas fa-map-marker-alt',
      title: 'Localização',
      value: 'Brasil',
      link: ''
    }
  ];

  return (
    <div className="contact-page" ref={root}>
      <section className="contact-hero">
        <div className="container" data-hero-reveal>
          <span className="eyebrow">Próximo passo</span>
          <h1 className="page-title">Vamos conversar sobre seu projeto</h1>
          <p className="page-subtitle">
            Conte brevemente seu desafio. A mensagem será preparada para você continuar pelo WhatsApp.
          </p>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Info */}
            <div className="contact-info-side">
              <h2>Informações de Contato</h2>
              <p className="contact-intro">
                Pode me chamar para contar uma ideia ou explicar o que precisa melhorar.
                Costumo responder em até um dia útil.
              </p>

              <div className="contact-info-list">
                {contactInfo.map((info, index) => (
                  <div key={index} className="contact-info-item" data-reveal>
                    <div className="info-icon">
                      <i className={info.icon}></i>
                    </div>
                    <div className="info-content">
                      <h4>{info.title}</h4>
                      {info.link ? (
                        <a 
                          href={info.link} 
                          target={info.link.startsWith('http') ? '_blank' : undefined}
                          rel={info.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                        >
                          {info.value}
                        </a>
                      ) : (
                        <p>{info.value}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="social-links-section">
                <h3>Outros canais</h3>
                <div className="social-links">
                  <a href="https://wa.me/5561995234306" target="_blank" rel="noopener noreferrer" title="WhatsApp">
                    <i className="fab fa-whatsapp"></i>
                  </a>
                  <a href="https://www.linkedin.com/in/samuel-neri-b8841b18a/" target="_blank" rel="noopener noreferrer" title="LinkedIn">
                    <i className="fab fa-linkedin"></i>
                  </a>
                  <a href="https://github.com/SamuelNeri" target="_blank" rel="noopener noreferrer" title="GitHub">
                    <i className="fab fa-github"></i>
                  </a>
                  <a href="mailto:samuell.nerii@gmail.com" title="Email">
                    <i className="fas fa-envelope"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-side" data-reveal>
              <form onSubmit={handleSubmit} className="contact-form">
                <span className="form-step">Leva menos de 2 minutos</span>
                <h2>Conte seu desafio</h2>
                
                <div className="form-group">
                  <label htmlFor="name">Nome Completo</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Seu nome"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact">E-mail ou WhatsApp</label>
                  <input
                    type="text"
                    id="contact"
                    name="contact"
                    value={formData.contact}
                    onChange={handleChange}
                    required
                    placeholder="Como prefere receber meu retorno?"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Como posso ajudar?</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={6}
                    placeholder="Ex.: preciso automatizar um processo que hoje é feito em planilhas..."
                  />
                </div>

                <button 
                  type="submit" 
                  className="submit-btn"
                >
                  Continuar no WhatsApp
                  <i className="fab fa-whatsapp" aria-hidden="true"></i>
                </button>
                <p className="form-privacy"><i className="fas fa-lock" aria-hidden="true"></i> Seus dados serão usados apenas para responder seu contato.</p>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
